import React from "react";
import { Form, Input, Checkbox } from 'antd';
import NHFormItem from '../../NHFormItem';
const FormItem = Form.Item;

/**
 * 学校信息编辑表单
 * @author yizhiqiang
 * @Email yizhiqiang@ly-sky.com
 * @date 2018-04-30
 * Version: 1.0
 */
class EditInitForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
        }
    }


    render() {
        const { form } = this.props;

        return (
            <div>
                <Form hideRequiredMark>
                    <NHFormItem id={'content'} label={'文本内容'} form={form} initialValue={this.props.content} required>
                        <Input style={{ width: '300px' }}
                            disabled={this.props.content ? true : false}
                        />
                    </NHFormItem>
                    <NHFormItem id={'href'} label={'链接地址'} form={form} required
                        pattern={{ pattern: /^((ht|f)tps?):\/\/.+$/, message: '请输入正确的链接' }}>
                        <Input style={{ width: '300px' }} placeholder={'链接地址'} />
                    </NHFormItem>
                    <NHFormItem id={'title'} label={'标题'} form={form} initialValue={this.props.content} required>
                        <Input style={{ width: '300px' }} />
                    </NHFormItem>
                    <NHFormItem id={'target'} label={'是否在新窗口打开'} form={form}>
                        <Checkbox />
                    </NHFormItem>
                </Form>

            </div>
        );
    }
}

const EditForm = Form.create()(EditInitForm);

export default EditForm;


// WEBPACK FOOTER //
// ./components/common/NHUeditor/link/EditForm.js